import type {
	COMM_BANNER_BG_COLOR_TYPE,
	COMM_BANNER_CONTENT_COLOR_TYPE,
	COMM_BANNER_TYPE,
} from 'fukku/CommsBanners/types'
import { OutletBrand, ShopBrand } from 'types/brands'
import type { Channel } from 'types/masterData'

import type { Section, SectionCTAs } from './query'

export enum PromoBannerLocation {
	Plp = 'plp',
	Cart = 'cart',
}

export enum DefaultBrands {
	defaultShop = 'defaultShop',
	defaultOutlet = 'defaultOutlet',
}

export type PromoBannerShopBrand = ShopBrand | DefaultBrands.defaultShop
export type PromoBannerOutletBrand = OutletBrand | DefaultBrands.defaultOutlet
export type PromoBannerBrand = PromoBannerShopBrand | PromoBannerOutletBrand

export type PromoBanner = {
	title: string
	backgroundColorType: COMM_BANNER_BG_COLOR_TYPE
	contentColor: COMM_BANNER_CONTENT_COLOR_TYPE
	customBackgroundColor: string
	sections: string[]
	type: COMM_BANNER_TYPE
	channel: Channel
	brand: PromoBannerBrand
	sectionsWithoutCTAs: Section[]
	showCountdown: boolean
	timeBeforeEnd: number
	promotion: PromotionContent
}

export type PromotionContent = {
	uid: string
	title: string
	subtitle: string
	name: string
	info: string
	startDate: string | null
	discount: string
	endDate: string
	linesCTAs: boolean
	sectionCTAs: SectionCTAs[]
}

export interface PromoBannerProps {
	location: PromoBannerLocation
	backgroundColor?: COMM_BANNER_BG_COLOR_TYPE
	withoutBorder?: boolean
	hideBannerIfNotInRange?: boolean
	maxDays?: number
	hideInfoText?: boolean
	className?: string
	alternativeSubtitle?: string
	catalogId?: string
	brand?: string
}
